// extracted by mini-css-extract-plugin
module.exports = {"close":"modal_confirmation_header-module__close--2CkO7","icon":"modal_confirmation_header-module__icon--2VFPf","title":"modal_confirmation_header-module__title--22IjF"};